var map = {
	"./@sections/about-shop/about-shop.js": 5044,
	"./@sections/articles-other/articles-other.js": 3840,
	"./@sections/articles/articles.js": 8511,
	"./@sections/benefits-hover/benefits-hover.js": 2161,
	"./@sections/benefits-swiper/benefits-swiper.js": 4250,
	"./@sections/categories/categories.js": 2347,
	"./@sections/characteristics/characteristics.js": 5817,
	"./@sections/comparison/comparison-diagram/comparison-diagram.js": 7172,
	"./@sections/comparison/comparison-table/comparison-table-block/comparison-table-block.js": 5515,
	"./@sections/comparison/comparison.js": 3452,
	"./@sections/faq-section/faq-section.js": 7547,
	"./@sections/features-swiper/features-swiper.js": 1216,
	"./@sections/filter/blocks/filter-colors/filter-colors.js": 466,
	"./@sections/filter/filter.js": 3161,
	"./@sections/glossary/glossary-block/glossary-block.js": 4719,
	"./@sections/header/blocks/dropdown-menu/dropdown-menu.js": 3441,
	"./@sections/header/blocks/dropdown-menu/js/dropdown-menu-core.js": 871,
	"./@sections/header/blocks/dropdown-menu/js/move-icons.js": 9482,
	"./@sections/header/blocks/dropdown-menu/js/switchable-menu.js": 7484,
	"./@sections/header/blocks/header-search/header-search.js": 3650,
	"./@sections/header/header.js": 1814,
	"./@sections/header/js/header-hamburger.js": 2391,
	"./@sections/instructions-all/elems/instructions-all-item/instructions-all-item.js": 5785,
	"./@sections/kit-contents/kit-contents.js": 4814,
	"./@sections/kit-profit/kit-profit.js": 9791,
	"./@sections/map-section/map-section.js": 5124,
	"./@sections/map-site/elems/map-site-block/map-site-block.js": 8811,
	"./@sections/new-products/new-products.js": 4866,
	"./@sections/order-verification/order-verification.js": 383,
	"./@sections/product-page-card/blocks/card-info/card-info.js": 7665,
	"./@sections/promotion-participates/promotion-participates.js": 894,
	"./@sections/ready-to-help/ready-to-help.js": 5606,
	"./@sections/related-products/related-products.js": 4586,
	"./@sections/resently-viewed/resently-viewed.js": 2809,
	"./@sections/reviews-slider/reviews-slider.js": 3069,
	"./@sections/search/search.js": 4181,
	"./@sections/selection/selection-breakpoints.js": 2636,
	"./@sections/selection/selection.js": 6977,
	"./@sections/sidebar-helpful/sidebar-helpful.js": 4357,
	"./@sections/slider-actions/slider-actions.js": 2285,
	"./@sections/slider-main/slider-main.js": 9964,
	"./@sections/text-inner/text-inner.js": 614,
	"./@sections/text-inners-form/elems/__file/__file.js": 7601,
	"./@sections/video-reviews/video-reviews.js": 7081,
	"./@sections/videos-about-product/videos-about-product.js": 9662,
	"./accordions/accordions.js": 5799,
	"./ajax/model-viewer/model-viewer.js": 7921,
	"./ajax/popup-modules/give-rating/give-rating.js": 2620,
	"./ajax/popup-modules/popup-input/popup-input.js": 6368,
	"./ajax/popup.js": 1862,
	"./ajax/popups.js": 9311,
	"./article-link/article-link.js": 4413,
	"./card-hover-slider/card-hover-slider.js": 7761,
	"./card-info-labels/card-info-labels.js": 3250,
	"./card-labels/card-labels.js": 3101,
	"./catalog-view-switcher/catalog-view-switcher.js": 1931,
	"./cookie/cookie.js": 8862,
	"./countdown/countdown.js": 1884,
	"./glossary-tooltip/glossary-tooltip.js": 4126,
	"./info-delivery/info-delivery.js": 7134,
	"./instruction-block/instruction-block.js": 195,
	"./payment-labels/payment-labels.js": 4476,
	"./popup-accordion/popup-accordion.js": 7705,
	"./price/price.js": 6023,
	"./product-page-labels/product-page-labels.js": 3465,
	"./product-page-slider/elems/product-page-slider-preview/product-page-slider-preview.js": 2022,
	"./product-page-slider/product-page-slider.js": 131,
	"./product-picker/product-picker.js": 395,
	"./review/review.js": 4403,
	"./sidebar-connection/sidebar-connection.js": 1791,
	"./simple-popup/simple-popup.js": 4348,
	"./slides-counter/slides-counter.js": 4609,
	"./submenu/submenu.js": 2943,
	"./tabs-mobile-select/tabs-mobile-select.js": 5362,
	"./tabs-nav/tabs-nav.js": 3098,
	"./tags/tags.js": 814,
	"./tooltip/tooltip.js": 6692,
	"./up-button/up-button.js": 3758
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5775;